import { get } from 'lodash'
import i18n from '@signavio/i18n'

import { applicationName } from '@signavio/effektif-commons'

export default function registrationButtonLabel(registration) {
  const user = registration.user
  if (!get(registration, 'salutation', '').trim()) {
    return i18n('Select a salutation')
  }

  if (!get(user, 'firstName', '').trim()) {
    return i18n('Enter your first name')
  }

  if (!get(user, 'lastName', '').trim()) {
    return i18n('Enter your last name')
  }

  if (!get(user, 'phone', '').trim()) {
    return i18n('Enter your phone number')
  }

  if (!get(user, 'country', '').trim()) {
    return i18n('Enter your country')
  }

  if (!user.password) {
    return i18n('Please enter a valid password')
  }

  if (!get(registration, 'tc')) {
    return i18n('Please accept the Terms and Conditions')
  }

  return i18n('Join __applicationName__', { applicationName })
}
